// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

var notEstablished = "Not established from the thread";

function pointerLine(clear, line) {
  if (clear && line !== undefined) {
    return line;
  } else {
    return notEstablished;
  }
}

function IssueBriefPointerCmp(Props) {
  var title = Props.title;
  var clear = Props.clear;
  var line = Props.line;
  var contact = Props.contact;
  var unclearClass = clear ? "" : " issue-brief-pointer--unclear";
  return React.createElement("div", {
              className: "issue-brief-pointer" + unclearClass
            }, React.createElement("p", {
                  className: "issue-brief-pointer-title"
                }, title), contact !== undefined ? React.createElement("p", {
                    className: "issue-brief-pointer-contact"
                  }, contact) : null, React.createElement("p", {
                  className: "issue-brief-pointer-line"
                }, pointerLine(clear, line)));
}

var make = IssueBriefPointerCmp;

export {
  notEstablished ,
  pointerLine ,
  make ,
  
}
/* react Not a pure module */
